module.exports = "images/9ans.d20c0804.png";